import { useTranslation } from '@mc/i18n'

import { SpecialTile } from './SpecialTile'
import { SquareTile } from './SquareTile'

export const ValuePropositionTiles = () => {
  const { t } = useTranslation('@mc/next')

  return (
    <div className='d-flex flex-column mc-gap-4'>
      <div className='d-flex flex-column flex-lg-row mc-gap-3'>
        {/* square tiles container */}
        <div className='d-flex flex-column flex-fill mc-gap-3'>
          <div className='d-flex mc-gap-3'>
            <div className='flex-fill'>
              <SquareTile
                text={t('pen-5368_v1.onCall')}
                imageUrl='https://static.masterclass.com/Tile%20-%20OnCall.jpg'
                hasAsterisk
              />
            </div>
            <div className='flex-fill'>
              <SquareTile
                text={t('pen-5368_v1.classGuides')}
                imageUrl='https://static.masterclass.com/Tile%20-%20ClassGuides.jpg'
              />
            </div>
          </div>
          <div className='d-flex mc-gap-3'>
            <div className='flex-fill'>
              <SquareTile
                text={t('pen-5368_v1.audioLessons')}
                imageUrl='https://static.masterclass.com/Tile%20-%20AudioMode.jpg'
              />
            </div>
            <div className='flex-fill'>
              <SquareTile
                text={t('pen-5368_v1.offlineMode')}
                imageUrl='https://static.masterclass.com/Tile%20-%20OfflineMode.jpg'
                hasAsterisk
              />
            </div>
          </div>
        </div>
        {/* special tile container */}
        <div className='flex-fill'>
          <SpecialTile
            text={t('pen-5368_v1.allClasses')}
            desktopImageUrl='https://static.masterclass.com/Tile%20-%20Classes%20XL.jpg'
            mobileImageUrl='https://static.masterclass.com/Tile%20-%20Classes.jpg'
          />
        </div>
      </div>
      <p className='d-block d-lg-none mc-text-small mc-text--center mc-opacity--muted'>
        *{t('pen-5368_v1.qualifierText')}
      </p>
      <p className='d-none d-lg-block mc-text--left mc-opacity--muted'>
        *{t('pen-5368_v1.qualifierText')}
      </p>
    </div>
  )
}
